// extracted by mini-css-extract-plugin
export default {"container":"Row_container__UNvxs","label":"Row_label__zzv4o"};